import { motion } from "framer-motion";
import { useLang } from "../i18n";
import { Reveal } from "./Reveal";

export const Tech = () => {
  const { t } = useLang();
  const s = t.tech;

  return (
    <section id="tech" className="relative py-24 lg:py-32 bg-ink-2/40 border-y border-line overflow-hidden">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: "radial-gradient(900px 500px at 15% 20%, rgba(0,75,147,0.3), transparent 60%)" }}
      />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 grid lg:grid-cols-12 gap-12 items-start">
        {/* image */}
        <Reveal className="lg:col-span-5 relative">
          <div className="sticky top-32 clip-frame border border-line p-2 bg-ink-2/70">
            <img src="/images/pack_welding.jpg" alt={s.imgCaption} className="w-full h-72 sm:h-96 lg:h-[520px] object-cover" data-testid="tech-image" />
            <p className="mono-label !text-[9px] px-2 pt-3 pb-1">{t.tech.imgCaption}</p>
          </div>
        </Reveal>

        {/* content */}
        <div className="lg:col-span-7">
          <Reveal>
            <p className="mono-label">{s.eyebrow}</p>
            <h2 className="mt-4 font-display uppercase font-bold tracking-tight leading-[0.95] text-3xl sm:text-4xl lg:text-5xl">
              {s.heading}
            </h2>
            <p className="mt-6 max-w-2xl text-txt-2 leading-relaxed">{s.lead}</p>
          </Reveal>

          <div className="mt-10 grid sm:grid-cols-3 gap-4">
            {s.cards.map((c, i) => (
              <Reveal key={i} delay={i * 0.1} className="card-surface p-6 hover:border-hadron-cyan/40 transition-colors" data-testid={`tech-card-${i}`}>
                <p className="font-mono2 text-[10px] text-hadron-cyan">0{i + 1}</p>
                <h3 className="mt-3 font-display uppercase font-bold text-xl text-txt">{c.t}</h3>
                <p className="mt-3 text-sm text-txt-2 leading-relaxed">{c.d}</p>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.1} className="mt-5">
            <h3 className="font-display uppercase font-bold text-2xl lg:text-3xl text-txt">{s.powertrainTitle}</h3>
            <div className="mt-5 grid sm:grid-cols-3 gap-px bg-line border border-line">
              {s.powertrain.map((p, i) => (
                <div key={i} className="bg-ink p-6" data-testid={`powertrain-${i}`}>
                  <p className="mono-label !text-[9px] !text-hadron-green">{p.t}</p>
                  <p className="mt-2.5 text-sm text-txt-2 leading-relaxed">{p.d}</p>
                </div>
              ))}
            </div>
          </Reveal>

          <Reveal delay={0.15} className="mt-12">
            <h3 className="font-display uppercase font-bold text-2xl lg:text-3xl text-txt">{s.fcTitle}</h3>
            <div className="mt-6 grid sm:grid-cols-2 gap-px bg-line border border-line">
              {s.fc.map((f, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.3 }}
                  transition={{ duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
                  className="bg-ink p-6 hover:bg-ink-2 transition-colors"
                  data-testid={`fourc-${i}`}
                >
                  <p className="font-mono2 text-[10px] text-hadron-green">C{i + 1}</p>
                  <p className="mt-2 font-display uppercase font-bold text-lg text-txt">{f.t}</p>
                  <p className="mt-2 text-sm text-txt-2">{f.d}</p>
                </motion.div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
